import {createCardsSvg as Icon__small__createCardsSvg} from '../Icon__small/Icon__small--createCards.js'

export var createCards = {
  name: 'createCards',
  category: 'icon',
  colorable: true,
  svg: Icon__small__createCardsSvg,
};
